.radioGroup label {
  margin-bottom: 10px;
  display: block;
}

.featuresList {
  color: white;
  padding-left: 20px;
}
